import { MDBox } from "../MDBox";
import { MDTypography } from "../MDTypography";
import BEE123_logo_primary from "../../../../assets/logo/BEE123_logo_primary.png";
import authenticated_shield from "../../../../assets/logo/authenticated_shield.png";

export const ClientFooterBanner: React.FC = () => {
  return (
    <>
      <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#FFFFFF", paddingY: "17px", marginTop: "20px" }}>
        <img
          className="footer_logo"
          src={BEE123_logo_primary}
          style={{
            maxWidth: "85px",
            marginRight: "15px",
          }}
          alt="BEE123 Logo"
        />
        <img
          className="footer_autheticated_shield"
          src={authenticated_shield}
          style={{
            maxWidth: "20px",
            marginRight: "15px",
          }}
          alt="BEE123 Logo"
        />
        <div>
          <MDTypography sx={{ fontSize: "17px" }}>
            BEE123 is the trusted and secure verification system that we use.
          </MDTypography>
          <MDTypography sx={{ fontSize: "17px" }}>
            For more information about BEE123 and how it can help your business&nbsp;
            <a href="https://www.bee123.co.za/bee123-management-software/" target="_blank" rel="noreferrer">
              visit our website
            </a>
            .
          </MDTypography>
        </div>
      </MDBox>
      <MDBox sx={{ height: '2px' }}>
      </MDBox>
    </>
  );
}